/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journaling for five minutes to process the day or plan tomorrow.`)
};

const es_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribir en un diario durante cinco minutos para procesar el día o planear el de mañana.`)
};

const de_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fünf Minuten journaln, um den Tag zu verarbeiten oder morgen zu planen.`)
};

const nl_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vijf minuten journalen om de dag te verwerken of morgen te plannen.`)
};

const fr_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrire dans son journal pendant cinq minutes pour digérer la journée ou planifier le lendemain.`)
};

const it_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivere sul diario per cinque minuti per elaborare la giornata o pianificare il domani.`)
};

const pt_br2_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrever no diário por cinco minutos para processar o dia ou planejar o amanhã.`)
};

const pt_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrever num diário durante cinco minutos para processar o dia ou planear o amanhã.`)
};

const ja_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その日を振り返ったり翌日の計画を立てたりするために5分間ジャーナリングする。`)
};

const zh_timer_u5m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`花五分钟写日记，梳理这一天或规划明天。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_use2", locale)
	if (locale === "en") return en_timer_u5m_use2(inputs)
	if (locale === "es") return es_timer_u5m_use2(inputs)
	if (locale === "de") return de_timer_u5m_use2(inputs)
	if (locale === "nl") return nl_timer_u5m_use2(inputs)
	if (locale === "fr") return fr_timer_u5m_use2(inputs)
	if (locale === "it") return it_timer_u5m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_use2(inputs)
	if (locale === "pt") return pt_timer_u5m_use2(inputs)
	if (locale === "ja") return ja_timer_u5m_use2(inputs)
	return zh_timer_u5m_use2(inputs)
};